import React from "react";

function Page(props) {

	return (
		<label>detalle encuesta</label>
	);
}

export default Page;